import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchdata } from '../reduxactions/organizationactions/OrgDonorReportGenActions';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import 'jspdf-autotable';
import { Panel } from 'primereact/panel';


const OrgDonorReportGenerate = () => {

  const uid = window.sessionStorage.getItem('uid');
  const dispatch = useDispatch();

  const location = useLocation();
  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("Id") as any);
  }, [location]);
  const { donorid } = useParams();
  const { rid } = useParams();

  // To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid, donorid, rid) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch])

  const data = useSelector((state: RootState) => state.orgdgen.data)
  const [globalFilter, setGlobalFilter] = useState('');

  //To print screen
  const print = () => window.print();
  //To export csv
  const exportToCSV = () => {
    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'transcript_data.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  //To export datatable as excel
  const exportToExcel = () => {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Create a blob with Excel MIME type
    const blob = new Blob([s2ab(XLSX.write(wb, { bookType: 'xlsx', type: 'binary' }))], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // Trigger download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'data.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Helper function to convert string to array buffer
  const s2ab = (s: string) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/vieworg-reports.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };



  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Donor Transcript</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <Panel>
              <div className="grid">
                <div className="col-12">
                  <div className="grid">
                    <div className="col-2">
                      <Button className='ml-3' label="CSV" icon="pi pi-file" onClick={() => exportToCSV()} />
                    </div>
                    <div className="col-2">
                      <Button className='ml-3' label="Excel" severity='success' icon="pi pi-file" onClick={exportToExcel} />
                    </div>
                    <div className="col-2">
                      <Button className='ml-3' label="Print" severity="warning" icon="pi pi-print" onClick={() => print()} />
                    </div>
                    <div className='col-2'>
                      <Button className='ml-3' label="Pdf" severity="info" icon="pi pi-pdf" onClick={() => print()} />
                    </div>
                  </div>


                  <div className="card flex flex-wrap justify-content-end my-2">
                    <span className="p-input-icon-left">
                      <i className="pi pi-search ml-2" />

                      <InputText
                        className="app-search-input"
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Global Search"
                      />
                    </span>
                  </div>
                  <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                    <Column field="nameoftheorg" sortable header="Organization"></Column>
                    <Column field="CountryName" sortable header="Country"></Column>
                    <Column field="send_date" sortable header="Paid Date"></Column>
                    <Column field="Amount" sortable header="Amount"></Column>

                  </DataTable>
                </div>
              </div>
            </Panel>

          </div>
        </div>
      </div>
    </div>
  )
}

export default OrgDonorReportGenerate